import type { ComponentType, SVGProps } from "react";
import { nav } from "../../copy/sq";
import { BriefingsIcon, CalendarIcon, SourcesIcon, SystemIcon, TodayIcon } from "../ui/icons";

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

/**
 * Phase 1 navigation. "My Topics" (Phase 2) is deliberately NOT listed
 * here — see ui/README.md's information-architecture note: the slot is
 * reserved conceptually (this array is the only place a future entry
 * would be added), not implemented, and not shown disabled/greyed out
 * (that would be visual clutter for a feature that doesn't exist yet).
 *
 * Labels come from copy/sq.ts — the UI is Albanian-first (V1, no
 * language switch).
 */
export const NAV_ITEMS: NavItem[] = [
  { to: "/", label: nav.today, icon: TodayIcon },
  { to: "/briefings", label: nav.briefings, icon: BriefingsIcon },
  { to: "/calendar", label: nav.calendar, icon: CalendarIcon },
  { to: "/sources", label: nav.sources, icon: SourcesIcon },
  { to: "/system", label: nav.system, icon: SystemIcon },
];
